import sanitizeHtml from 'sanitize-html';
import { isNil } from 'ramda';
import { match } from 'ts-pattern';

export const S = {
    has: (key: string, obj: any): boolean => {
        // eslint-disable-next-line no-prototype-builtins
        return obj && key && obj.hasOwnProperty(key);
    },
    formatCamelCase: (text: string): string => {
        const result = text.replace(/([A-Z])/g, ' $1');
        return result.charAt(0).toUpperCase() + result.slice(1);
    },
    capitalizeFirstLetter: (text: string): string => text.charAt(0).toUpperCase() + text.slice(1),
    escapeHtml: (str: string) =>
        str.replace(
            /[&<>'"]/g,
            (tag) =>
                ({
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    "'": '&#39;',
                    '"': '&quot;',
                }[tag] || tag),
        ),
    isMacOS: () => window.navigator.userAgent.indexOf('Mac OS') !== -1,
    sanitizeHtml: (input: string) => sanitizeHtml(input, { allowedAttributes: false, disallowedTagsMode: 'escape' }),
    fillWithZeros: (arg: number | string, length: number) => {
        let stringToFill = String(arg).trim();
        for (let i = 0; i < length - String(arg).length; i++) {
            stringToFill = `0${stringToFill}`;
        }
        return stringToFill;
    },
    bytesConvertToLargerUnit(bytes: number, decimals: number = 2): string {
        // Handle the edge case of 0 bytes.
        if (bytes === 0) {
            return '0 B';
        }
        if (decimals < 0) decimals = 0;
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        const formattedValue = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));
        return `${formattedValue} ${sizes[i]}`;
    },
    formatDurationInSeconds(totalSeconds: number, dateType: string) {
        if (isNil(totalSeconds)) return totalSeconds;

        if (totalSeconds === 0)
            return match(dateType)
                .with('datetime', () => '0d')
                .with('date', () => '0d')
                .with('time', () => '0h')
                .otherwise(() => '0');
        // Define time constants
        const secondsInADay = 86400;
        const secondsInAnHour = 3600;
        const secondsInAMinute = 60;

        const days = Math.floor(totalSeconds / secondsInADay);
        const remainingAfterDays = totalSeconds % secondsInADay;

        const hours = Math.floor(remainingAfterDays / secondsInAnHour);
        const remainingAfterHours = remainingAfterDays % secondsInAnHour;

        const minutes = Math.floor(remainingAfterHours / secondsInAMinute);
        const seconds = remainingAfterHours % secondsInAMinute;

        const parts = [];

        if (days > 0) {
            parts.push(`${days}d`);
        }
        if (hours > 0) {
            parts.push(`${hours}h`);
        }
        if (minutes > 0) {
            parts.push(`${minutes}m`);
        }
        if (seconds > 0) {
            parts.push(`${seconds}s`);
        }

        // Join all parts with a space
        return parts.join(' ');
    },
};
